import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cross",
  "use": "icon-cross-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-cross\">\r\n    <path d=\"M0 18.6L18.6 0 20 1.4 1.4 20 0 18.6zM1.4 0L20 18.6 18.6 20 0 1.4 1.4 0z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol